import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import { Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { ColStack } from './InCardStack'
import colors from 'styles/colors'

export const Welcome = ({ headLine, title, description, children }) => {
  return (
    <Stack spacing={4} padding={0}>
      {headLine && <Typography variant='h4'>{headLine}</Typography>}
      {title && <Typography variant='h2'>{title}</Typography>}
      {description && (
        <Typography variant='body1' color='textSecondary'>
          {description}
        </Typography>
      )}
      {children}
    </Stack>
  )
}

export const DescWithInfoCards = ({
  children,
  welcomeElement = null,
  containerSx = {}
}) => {
  return (
    <ColStack spacing={16}>
      {welcomeElement}
      <BoxWithBackground
        borderRadius={3}
        backgroundColor={colors.MutedTeal300}
        width='100%'
        sx={containerSx}>
        <BoxWithBackground
          borderRadius={3}
          backgroundColor={colors.White}
          padding={16}>
          <Grid container spacing={0} gap={12} justifyContent={'space-evenly'}>
            {children}
          </Grid>
        </BoxWithBackground>
      </BoxWithBackground>
    </ColStack>
  )
}

const HeaderWithInfoCards = ({
  children,
  welcomeElement = null,
  containerSx = {}
}) => {
  return (
    <BoxWithBackground
      paddingY={32}
      paddingX={20}
      width='100%'
      sx={containerSx}>
      <Grid container spacing={12}>
        {welcomeElement && (
          <Grid size={{ md: 12, lg: 3 }}>{welcomeElement}</Grid>
        )}
        <Grid
          container
          size={{ md: 12, lg: welcomeElement ? 9 : 12 }}
          columnSpacing={12}>
          {children}
        </Grid>
      </Grid>
    </BoxWithBackground>
  )
}

export default HeaderWithInfoCards
